import React from 'react';
import { Button } from '../ui/button';
import { Newspaper } from 'lucide-react';

interface NewsButtonProps {
  playerId: string;
  playerName?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'outline' | 'ghost';
  onClick?: () => void;
  className?: string;
}

export const NewsButton: React.FC<NewsButtonProps> = ({
  playerId,
  playerName,
  size = 'sm',
  variant = 'outline',
  onClick,
  className = ''
}) => {
  // Size classes
  const sizeClasses = {
    sm: 'h-6 w-6 p-0',
    md: 'h-8 w-8 p-0',
    lg: 'h-10 w-10 p-0'
  };

  // Icon sizes
  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  // Size-specific classes for buttons with text
  const textSizeClasses = {
    sm: 'h-6 px-2 py-0 text-xs',
    md: 'h-8 px-2.5 py-0 text-sm',
    lg: 'h-10 px-3 py-0 text-base'
  };

  return (
    <Button
      variant={variant}
      size="sm"
      className={`${textSizeClasses[size]} bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 text-white dark:text-white border border-blue-600 dark:border-blue-700 flex items-center gap-1 ${className}`}
      title={`View news articles for ${playerName || 'this player'}`}
      onClick={onClick}
    >
      <Newspaper className={iconSizes[size]} />
      <span>News</span>
    </Button>
  );
};